import {
  useGetList,
  useListContext,
  useRecordContext,
  LoadingIndicator,
} from "react-admin";
import { useMemo } from "react";
import groupBy from "lodash/groupBy";
import uniq from "lodash/uniq";
import get from "lodash/get";

export const PreloadedManyField = ({
  source,
  reference,
  target,
  render,
  itemFormat = (v) => v,
  selectRecord,
  ...rest
}) => {
  let { data: listData } = useListContext(rest); // List of all records in the table
  const currentRecord = useRecordContext(); // Current row in Datagrid

  listData = listData || [currentRecord];

  const recordIds = useMemo(() => {
    if (!listData) return [];
    return uniq(listData.map((record) => get(record, source)).filter((v) => v));
  }, [listData]);

  const { data: relatedData, isLoading } = useGetList(reference, {
    filter: { [target]: recordIds },
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "id", order: "ASC" },
  });

  const dataByTarget = useMemo(() => {
    return groupBy(relatedData || [], target);
  }, [relatedData, target]);

  if (isLoading) return <LoadingIndicator />;

  const currentSourceValue = get(currentRecord, source);
  let relatedForThisRow = selectRecord
    ? relatedData.filter((relatedRecord) =>
        selectRecord(currentRecord, relatedRecord)
      )
    : dataByTarget[currentSourceValue] || [];
  relatedForThisRow = relatedForThisRow.map(itemFormat);

  return <>{render(relatedForThisRow)}</>;
};
